import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import React, { useEffect, useState } from "react";
import { useAPIEditAlatBerat } from "../api/api-edit-alat-berat";
import {
  genElBoolean,
  genElObject,
  genElText,
} from "@components/utils/EditorDialogElementGenerator";
import { ProgressSpinner } from "primereact/progressspinner";
import DepartmentSelectorDialog from "../../../../dialogs/selectors/DepartmentSelectorDialog";
import JenisMinyakSelectorDialog from "../../../../dialogs/selectors/JenisMinyakSelectorDialog";

const AlatBeratEdit = (props) => {
  const { visible, onHide, editorData, onConfirmed } = props;

  const [showDepartmentSelector, setShowDepartmentSelector] = useState(false);
  const [showJenisMinyakSelector, setShowJenisMinyakSelector] = useState(false);

  const {
    loading,
    data,
    setData,
    setError,
    fetchDataOrCreateNew,
    error,
    handleOnConfirm,
  } = useAPIEditAlatBerat({ onConfirmed });

  // use effect section

  useEffect(() => {
    if (visible) {
      setError({});
      fetchDataOrCreateNew({ id: editorData.id, extraData: editorData });
    }
  }, [visible]);

  // handle ui event section

  const handleOnConfirmDepartment = (event, datas) => {
    if (datas && datas.length > 0) {
      const department = datas[0];
      setData((prevData) => ({
        ...prevData,
        data_department: department,
        department_id: department.id,
      }));
      setShowDepartmentSelector(false);
    }
  };

  const handleOnConfirmJenisMinyak = (event, datas) => {
    if (datas && datas.length > 0) {
      const jenisMinyak = datas[0];
      setData((prevData) => ({
        ...prevData,
        data_jenis_minyak: jenisMinyak,
        jenis_minyak_id: jenisMinyak.id,
      }));
      setShowJenisMinyakSelector(false);
    }
  };

  // genereate editor element section

  const elKodeUnit = genElText({
    field: "kode_unit",
    name: "Kode Unit",
    data,
    setData,
    error,
  });

  const elNama = genElText({
    field: "nama",
    name: "Nama",
    data,
    setData,
    error,
  });

  const elJenisAlat = genElText({
    field: "jenis_alat",
    name: "Jenis Alat",
    data,
    setData,
    error,
  });

  const elDepartment = genElObject({
    field: "department_id",
    name: "Department",
    value: data.data_department ? data.data_department.nama : "",
    error,
    onClick: () => setShowDepartmentSelector(true),
  });

  const elJenisMinyak = genElObject({
    field: "jenis_minyak_id",
    name: "Jenis Minyak",
    value: data.data_jenis_minyak ? data.data_jenis_minyak.nama : "",
    error,
    onClick: () => setShowJenisMinyakSelector(true),
  });

  const elStatus = genElBoolean({
    field: "status",
    name: "Status",
    labelTrue: "Aktif",
    labelFalse: "Tidak Aktif",
    data,
    setData,
    error,
  });

  const elKeterangan = genElText({
    field: "keterangan",
    name: "Keterangan",
    data,
    setData,
    error,
  });

  const dialogFooter = (
    <React.Fragment>
      <Button
        label="Cancel"
        icon="pi pi-times"
        outlined
        onClick={props.onHide}
      />
      <Button
        label="Save"
        icon="pi pi-check"
        onClick={(e) => {
          handleOnConfirm();
        }}
      />
    </React.Fragment>
  );

  return (
    <Dialog
      visible={visible}
      style={{ width: "32rem" }}
      breakpoints={{ "960px": "75vw", "641px": "90vw" }}
      header={data.id && data.id > 0 ? "Edit Alat Berat" : "Tambah Alat Berat"}
      modal
      className={`p-fluid`}
      footer={dialogFooter}
      onHide={onHide}
      contentClassName="py-4 !pb-6"
      pt={{ footer: { className: "py-4" }, header: { className: "py-4" } }}
    >
      <DepartmentSelectorDialog
        title={"Pilih Department"}
        visible={showDepartmentSelector}
        onHide={() => setShowDepartmentSelector(false)}
        onConfirm={handleOnConfirmDepartment}
      />

      <JenisMinyakSelectorDialog
        title={"Pilih Jenis Minyak"}
        visible={showJenisMinyakSelector}
        onHide={() => setShowJenisMinyakSelector(false)}
        onConfirm={handleOnConfirmJenisMinyak}
      />

      <div className="col-start-center relative h-100 gap-3">
        {elDepartment}
        {elKodeUnit}
        {elNama}
        {elJenisAlat}
        {elJenisMinyak}
        {elStatus}
        {elKeterangan}
        {loading && (
          <div
            className={`col-center-center w-100  gap-2 absolute z-100 h-100 bg-black/20 rounded `}
          >
            <ProgressSpinner />
          </div>
        )}
      </div>
    </Dialog>
  );
};

export default AlatBeratEdit;
